import css from '../../TextEditor/components/TextEditorFile/TextEditorFile.module.css'
import { TextMidd } from '@/components/ui/Text'

const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} b`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} kb`
    return `${(bytes / (1024 * 1024)).toFixed(1)} mb`
}

// Read-only file node for the static viewer. Saved content is never `uploading`,
// so the loading branch is dropped; no Slate selection state.
const StaticFile = ({ attributes, children, element }: any) => (
    <div {...attributes}>
        <div contentEditable={false} className={css.wrapper}>
            <a href={element.url} target="_blank" rel="noopener noreferrer" className={css.link}>
                <TextMidd className={css.name}>{element.fileName}</TextMidd>
                {element.fileSize &&
                    <span className={css.size}><TextMidd>{formatFileSize(element.fileSize)}</TextMidd></span>
                }
            </a>
        </div>
        {children}
    </div>
)

export default StaticFile
